import { flowTypes, pageConfig } from "@/common/service/page-config";
import { SHARE_TYPE_ENUM, generateCartIdWithQueryKey } from "@/views/config/shopping-cart/share-link.vue";

export const isCartBuilderAddQty = pageConfig.type === flowTypes.buyNow && SHARE_TYPE_ENUM.ADD_QTY === pageConfig[generateCartIdWithQueryKey];